import { useMemo } from "react";
/**
 * The lifecycle every rich tool part shares (plan 009 §6.9): a placeholder while
 * the model assembles the call, a muted error card for a failed one, and the
 * real rendering only once the payload survives the tool's own output schema.
 *
 * That parse is the boundary — the live stream is not validated by the
 * transport, so a malformed payload must degrade to the error card rather than
 * throw inside the transcript or turn a download button into a request to an
 * arbitrary URL.
 *
 * The parse is memoised on the payload, but NOT for the streaming turn: the AI
 * SDK's `ReactChatState.replaceMessage` deep-clones the whole message on every
 * update (`structuredClone`), so `part.output` is a fresh reference each frame
 * and this cache misses every time. What keeps a landed view from re-rendering
 * per frame is the id-level `memo()` on each view component — they take ids, not
 * the parsed payload, precisely so a fresh parse cannot churn them. The memo
 * still earns its place once the part has settled and the message stops being
 * replaced: re-renders from elsewhere then reuse the parse.
 */ export function ToolPartBlock({ part, schema, skeleton, error, children }) {
    const parsed = useMemo(()=>schema.safeParse(part.output), [
        schema,
        part.output
    ]);
    if (part.state === "input-streaming" || part.state === "input-available") return skeleton;
    if (part.state === "output-error" || !parsed.success) return error;
    return children(parsed.data);
}

//# sourceMappingURL=tool-part-block.js.map